import React from 'react'
import { useEffect, useState } from 'react'
import $ from 'jquery'
import getDomainName from 'helpers/getDomainName'

const Reporting = () => {
  const [embedUrl, setEmbedUrl] = useState()
  const [parameter, setParameter] = useState({
    sessionId: localStorage.getItem('userLoginSessionId'),
    accessToken: localStorage.getItem('accessToken'),
    domain: getDomainName(),
  })

  const createQueryString = params => {
    return Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&')
  }

  useEffect(() => {
    $('#pageLoading').show()
    ;(async () => {
      try {
        const addQueryParam = `https://egalvanic.retool.com/embedded/public/545a0bf1-9d3d-4467-8fb5-186dabcb1efb/Reporting?${createQueryString(parameter)}`
        setEmbedUrl(addQueryParam)
        $('#pageLoading').hide()
      } catch (error) {
        $('#pageLoading').hide()
        console.log(error)
      }
    })()
  }, [])
  return <iframe src={embedUrl} title='description' style={{ height: 'calc(100vh - 70px)', width: '100%' }}></iframe>
}

export default Reporting
